import React from 'react'
import SocialMediaLinkList from '../General/SocialMediaLinkList'
import FooterText from './FooterText'
import ServicePagesMenu from './ServicePagesMenu'


const Footer = ({siteHeaderData, cinemaData, socialmediaData}) => {
    const { homeURL, siteName } = siteHeaderData

    return (
        <div className="site-footer-linkbox grid-site-wrapper">
            <div className="wrapper-center">

                <div className="logo-wrapper">
                    <p className="site-footer-title site-logo">
                        <a className='logo-image' href={homeURL} rel="home">
                            <span className="screen-reader-text">{siteName}</span>
                        </a>
                    </p>
                </div>

                <div key="2" className="site-footer-contactbox">
                        <p className="text-small-footer">
                            <FooterText cinemaData={cinemaData}/>
                        </p>
                </div>

                <div className="wrapper-center-y link-social-wrapper">
                    <SocialMediaLinkList socialmediaData={socialmediaData} />
                </div>
            </div>
        </div>
    )
}

export default Footer